export enum AnnexedParameters {
  MODELO_FECHA_EFECTO = 1,
  FH_EFECTO = 2,
  ALTA_CONDICIONADA = 3,
  SUBROGACION = 4,
  MOTIVO_RECHAZO = 5,
  PEAJE = 6,
  Q_DIARIO = 7,
  TELEMEDIDA = 8,
  CONSUMO_ANUAL = 9,
  FH_ULTIMA_INSPECCION = 10,
  RES_ULTIMA_INSPECCION = 11,
  CODIGO_ATR = 12,
  Q_HORARIO = 13,
  PRESION_SOLICITADA = 14,
  USO_GAS = 15,
  PROPIEDAD_CONTADOR = 16,
  TRANSFORMACION_APARATOS = 17,
  NUM_APARATOS_TRANSFORMAR = 18,
  COMENTARIOS = 19,
  NOMINACION_INDIVIDUAL = 20,
  RED_UBICACION = 21,
  ESTADO_SUMINISTRO = 22,
  DESCRIPCION_RECHAZO = 23,
  VIVIENDA_HABITUAL = 24,
  NUMERO_VISITA = 25,
  GAS_CONTESTACION_INCIDENCIA = 26,
  NOMBRE_CONTACTO = 27,
  TELEFONO_CONTACTO = 28,
  MAIL_CONTACTO = 29,
  NUMERO_BOE = 30,
  QD_CONTRATADO = 31,
  QD_APLICADO = 32,
  QD_MAXIMO = 33,
  INCENTIVOS_ER_COG_Y_RES = 34,
  COSTES_DIST_Y_TRANS = 35,
  OTROS_COSTES_REGULADOS = 36,
  FH_QD_MAXIMA = 37,
  QD_MEDIO = 38,
  CONTROL_POT = 39,
  VAS_TRAFO = 40,
  PORCENTAJE_PERD = 41,
  CURVA_CARGA = 42,
  FECHA_BOE = 43,
  RANGO_PRESION_DISENO = 44,
  TIPO_GASINERA = 45,
  METODO_FACTURACION = 46,
  DIAS_CAPACIDAD_CONTRATADA = 47,
  MULT_EXCESO_CAUDAL = 48,
  COEFICIENTE_CORTO_PLAZO = 49,
  EXCESO_CAUDAL = 50,
  HORAS_CAPACIDAD_CONTRATADA = 51,
  BONO_SOCIAL = 52,
  MODO_CONTROL_POTENCIA = 53,
  POTENCIA = 54,
  FH_ACEPTACION_RECHAZO = 55,
  APLICAN_PERDIDAS = 56,
  RECORE = 57,
  ANUALIDADES_DEFICIT = 58,
  SOBRECOSTE_TNP = 59,
  CNAE = 60,
  TENSION_SOLICITADA = 61,
  AC_TIPO = 62,
  MOTIVO_BAJA = 63,
  SOLICITUD_ANULADA = 64,
  VALOR_ENERGIA_MEDIA_CP = 65,
  CODIGO_CIE = 66,
  POTENCIA_INST_BT = 67,
  FH_EMISION_CIE = 68,
  FH_CAD_CIE = 69,
  NIF_INSTALADOR = 70,
  TENSION_SUM_CIE = 71,
  REG_DOC_URL_DOCUMENTO = 72,
  REG_DOC_TIPO_DOCUMENTO = 73,
  TIPO_SUMINISTRO = 74,
  LG_EXENTO = 75,
  LG_BONO_SOCIAL = 76,
  GAS_TIPO_RECLAMANTE = 77,
  GAS_TIPO_RECLAMACION = 78,
  GAS_SUBTIPO_RECLAMACION = 79,
  FECHA_LIMITE = 80,
  PRIORITARIO = 81,
  GAS_CONCEPTO_CONTRATACION = 82,
  GAS_CONCEPTO_FACTURACION = 83,
  PWR_TIPO_RECLAMACION = 84,
  PWR_SUBTIPO_RECLAMACION = 85,
  PWR_TIPO_RECLAMANTE = 86,
  PWR_CONCEPTO_CONTRATACION = 87,
  PWR_CONCEPTO_FACTURACION = 88,
  CODIGO_INCIDENCIA = 89,
  FH_DESDE = 90,
  FH_HASTA = 91,
  G1_SUBTIPO_RECLAMACION = 92,
  G2_SUBTIPO_RECLAMACION = 93,
  G3_SUBTIPO_RECLAMACION = 94,
  G4_SUBTIPO_RECLAMACION = 95,
  G5_SUBTIPO_RECLAMACION = 96,
  G6_SUBTIPO_RECLAMACION = 97,
  G7_SUBTIPO_RECLAMACION = 98,
  P1_SUBTIPO_RECLAMACION = 99,
  P2_SUBTIPO_RECLAMACION = 100,
  P3_SUBTIPO_RECLAMACION = 101,
  P4_SUBTIPO_RECLAMACION = 102,
  P5_SUBTIPO_RECLAMACION = 103,
  P6_SUBTIPO_RECLAMACION = 104,
  P7_SUBTIPO_RECLAMACION = 105,
  PWR_TIPO_COMUNICACION = 106,
  PWR_TIPO_INFORMACION_ADICIONAL = 107,
  PWR_RESULTADO_RECLAMACION = 108,
  PWR_DETALLE_RESULTADO = 109,
  GAS_RESULTADO_RECLAMACION = 110,
  GAS_DETALLE_RESULTADO = 111,
  TIPO_INTERVENCION = 112,
  GAS_TIPO_INFORMACION = 113,
  RESULTADO_INSPECCION = 114,
  ANOMALIA_INSTALACION = 115,
  GAS_TIPO_INFORMACION_ADICIONAL = 116,
  FH_INTERVENCION = 117,
  TIPO_CIERRE = 118,
  CODIGO_CLIENTE = 119,
  PWR_TIPO_CONTRATO_ATR = 121,
  MOTIVO_MODIFICACION = 122,
  GARANTE = 123,
  ELECTROINTENSIVO = 124,
  REGION_IMPUESTOS = 125,
  FH_TENTATIVA = 126,
  DURACION_CONTRATO = 127,
  COMP_BONIFICACION = 128,
  CALIDAD_BAD = 129,
  TIPO_SEGMENTO = 130,
  VIGENCIA = 131,
  NIVEL_PRESION = 132,
  CURVA_REAL = 133,
  MULTICUPS = 134,
  CUPS = 135,
  DIAS_PAGO = 136,
  GESTION_ATR = 137,
  NIVEL_FACTURACION = 138,
  INICIO_CONTRATO = 139,
  TIPO_COMPRA = 140,
  DOC_CUENTA = 141,
  AC_TIPO_CUPS = 142,
  AC_REF_CATASTRAL = 143,
  AC_CAU = 144,
  AC_SUBSECCION = 145,
  AC_COLECTIVO = 146,
  AC_CIL = 147,
  AC_TIPO_GENERACION = 148,
  AC_COMBUSTIBLE = 149,
  AC_POTENCIA_INSTALADA = 150,
  AC_TIPO_INSTALACION = 151,
  AC_ESQUEMA_MEDIDA = 152,
  AC_SSAA = 153,
  AC_UNICO_CONTRATO = 154,
  AC_FH_CAMBIO = 155,
  PWR_MOTIVO_CAMBIO = 156,
  GAS_MOTIVO_CAMBIO = 157,
  PERIODICIDAD_FACTURACION = 158,
  PWR_CLIENTE_ESENCIAL = 159,
  FH_MOVIMIENTO_ESENCIAL = 160,
  POTENCIA_NO_INT = 161,
  CODIGO_INSTALADOR = 162,
  SELLO_ELECTRONICO_CIE = 163,
  VALIDEZ_CIE = 164,
  GAS_CLIENTE_ESENCIAL = 165,
  GAS_CLIENTE_PROTEGIDO = 166,
  TIPO_DESISTIMIENTO = 167,
  GAS_TIPO_OPERACION = 168,
  FECHA_INTERVENCION = 169,
  MOTIVO_INCIDENCIA_CAMPO = 170,
  PWR_CONTESTACION_INCIDENCIA = 171,
  DESCRIPCION_INFORMACION_ADICIONAL = 172,
  TIPO_LIQUIDACION = 173,
  TIPO_PRODUCTO = 174,
  GAS_TIPO_CONTRATO_ATR = 175,
  TIPO_REPOSICION = 176,
  RESULTADO_REPOSICION = 177,
  MOTIVO_RECHAZO_REPOSICION = 178,
  NUEVA_PERSONA_CONTACTO = 179,
  NUEVO_PREFIJO = 180,
  NUEVO_NUMERO_TELEFONO = 181,
  NUEVO_EMAIL = 182,
  FH_INICIO_OFERTA = 183,
  FH_FIN_OFERTA = 184,
  MOTIVO_MODIFICACION_PWR = 185,
  MOTIVO_FACTURACION = 186,
  MESES_CONTRATO = 187,
  NRO_DOC_CIE_IMPUESTOS = 188,
  PORCENTAJE_CIE_IMPUESTOS = 189,
  F_INICIO_CIE_IMPUESTO = 190,
  F_FIN_CIE_IMPUESTO = 191,
  ARTICULO_CIE_IMPUESTO = 192,
  CARGOS_FUTURO = 193,
  FECHA_CARGOS = 194,
  DEUDA_CARGOS = 195,
  NIVEL_CONSUMO = 196,
  AGREGADOR_OFERTA = 202,
  LG_GDO = 203,
  REF_CATASTRAL_FINCA = 204,
  CIF_PAGADOR = 205,
  RAZON_SOCIAL_PAGADOR = 206,
  EXENTO_IEH = 207,
  MOTIVO_RECHAZO_PWR = 208,
  MOTIVO_RECHAZO_GAS = 209,
  GAS_RESULTADO_REPOSICION = 210,
  GAS_MOTIVO_RECHAZO_REPOSICION = 211,
  IND_ANULABLE = 212
}
